import { List } from "react-admin";
import { PageTitle } from "../../misc/PageTitle";
import { Row } from "../../misc/Row";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { useCurrentDrivingSchoolId } from "../../hooks/useCurrentDrivingSchoolId";
import { AccessDenied } from "../../misc/AccessDenied";
import { grants } from "../../backoffice.access_control";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { ServiceTypesDataGrid } from "./ServiceTypesDataGrid";

export function DrivingSchoolServiceTypes() {
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const navigate = useNavigate();

  if (!grants.has("ServiceType:list")) {
    return <AccessDenied />;
  }

  const empty = <EmptyState noEntriesText="Noch kein Rechnungstyp angelegt." />;

  return (
    <div style={{ position: "relative" }}>
      <Row
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
      >
        <PageTitle documentTitle="Rechnungstypen">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>Rechnungstypen</h2>
        </PageTitle>
        <IconButton
          aria-label="Rechnungstyp hinzufügen"
          color="primary"
          onClick={() => navigate("/serviceTypes/create")}
          size="small"
          sx={{ display: { xs: "inline-flex", sm: "none" } }}
        >
          <AddIcon />
        </IconButton>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => navigate("/serviceTypes/create")}
          size="small"
          sx={{ display: { xs: "none", sm: "inline-flex" } }}
        >
          Hinzufügen
        </Button>
      </Row>
      <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolServiceTypes">
        <List
          resource="serviceTypes"
          title=" "
          actions={false}
          filter={{ drivingSchoolId }}
          sort={/* initial sort order: */ { field: "title", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          empty={empty}
        >
          <ServiceTypesDataGrid empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
